import { Navigate } from '@tanstack/react-router';
import { Empty } from 'cpool-components/state/Empty';
import { Spinner } from 'cpool-components/state/Spinner';
import { useTranslation } from 'react-i18next';
import { LuMessageCircle } from 'react-icons/lu';

import { CommunicationPage } from './index';
import { useChatEntryState } from '~/features/whatsapp/hooks/useChatEntryState';
import { getChatEntryBlockedKey } from '~/features/whatsapp/utils/getChatEntryBlockedKey';
import { CHAT_ENTRY_STATES } from '~/features/whatsapp/utils/resolveChatEntryState';

export const CommunicationRoutePage = () => {
    const { t } = useTranslation();
    const chatEntryState = useChatEntryState();

    if (chatEntryState === CHAT_ENTRY_STATES.LOADING)
        return (
            <div className="flex flex-1 items-center justify-center p-8" data-testid="communication-loading">
                <Spinner />
            </div>
        );

    if (chatEntryState === CHAT_ENTRY_STATES.HIDDEN) return <Navigate replace to="/accessdenied" />;

    if (chatEntryState !== CHAT_ENTRY_STATES.ENABLED)
        return (
            <div
                className="flex flex-1 items-center justify-center bg-surface-light p-8"
                data-testid="communication-blocked"
            >
                <Empty
                    icon={<LuMessageCircle />}
                    title={t(getChatEntryBlockedKey(chatEntryState) ?? 'WHATSAPP_CHAT.ENTRY_LOAD_ERROR')}
                />
            </div>
        );

    return <CommunicationPage />;
};
